<template>
  <div class="c-card-off">
    <div class="c-card-off__img-wrapper">
    </div>
    <section class="c-card-off__section">
      <div class="c-card-off__info">
        <img
          src="@/projects/people/assets/img/card-off/logo-synergy-id.svg"
          alt="avatar"
          class="c-card-off__info-img"
        />
        <h1 class="c-card-off__info-title">
          Tехнические работы
        </h1>
        <p class="c-card-off__info-subtitle">
          Мы меняемся к лучшему, поэтому сейчас проводим технические работы. Очень скоро личный кабинет снова станет доступен. Пожалуйста, попробуйте позднее.
        </p>
        <p class="c-card-off__info-text">
          Для решения срочных вопросов свяжитесь со службой поддержки
          <a
            href="mailto:help@synergyfriends.ru"
            class="c-card-off__info-text--color"
          >
            help@synergyfriends.ru
          </a>
        </p>
      </div>
    </section>
  </div>
</template>

<style lang="scss">
@import './TheCabinetOff.scss';
</style>
